import React from "react";
import { useMemo } from "react";

import { PageLoader } from "clearsense-ui/components";
import { EmptyState } from "components/Common";

import BarChart from "./BarChart";
import { getDistributionData } from "./data";
import PieChart from "./PieChart";

function PredictionsCharts({ summary, isLoading }) {
  const data = useMemo(
    () => summary && getDistributionData(summary),
    [summary]
  );

  if (isLoading) {
    return <PageLoader />;
  } else if (!data) {
    return <EmptyState />;
  }

  return (
    <div className="grid grid-cols-1 gap-4 mb-5 lg:grid-cols-2 xl:grid-cols-2">
      <PieChart title="Prediction Outcome" data={data?.predictionOutcome} />
      <PieChart title="Out of Range Values" data={data?.outOfRange} />
      <BarChart
        title="Positive Prediction Confidence Distribution"
        data={data?.positiveDistribution}
      />
      <BarChart
        title="Negative Prediction Confidence Distribution"
        data={data?.negativeDistribution}
      />
    </div>
  );
}

export default PredictionsCharts;
